import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ReadinessCheck from "@/pages/ReadinessCheck";

export const Route = createFileRoute("/readiness-check")({
  head: () => seoHead("/readiness-check"),
  component: ReadinessCheck,
});
